import { parseFinite } from 'util/number'

export type Range = {
  min: number
  max: number
}

export function parseRange(value: string): Range | undefined {
  if (!value) return undefined
  const parts = value.split('-')
  const a = parseFinite(parts[0])
  const b = parseFinite(parts[1])
  if (a == null || b == null) return undefined
  const min = Math.min(a, b)
  const max = Math.max(a, b)
  return { min, max }
}

export function inRange(range: Range | undefined, value: number | undefined): boolean {
  if (range == null || value == null) return false
  const { min, max } = range
  return value >= min && value <= max
}

export function getMid(range: Range | undefined, round?: true): number | undefined {
  if (range == null) return undefined
  const { min, max } = range
  const mid = (max - min) / 2
  return round ? Math.round(mid) : mid
}
